import { Environment } from '@/types/misc';
import { CustomFieldType } from '@/types/customField';

/**
 * DO NOT CHANGE THIS EVER.
 * For changing your local environment, see Makefile.
 */
const ENVIRONMENT: Environment = (process.env.NEXT_PUBLIC_ENVIRONMENT as Environment) || 'prd';

// AsturDefaults: Defaults for various astur related things
// (in production the keycloak stuff comes from a generated config file that gets loaded in the browser)
export const ASTUR_DEFAULTS = {
  keycloakRealm: 'acenda', // keycloak realm
  keycloakClientId: 'astur_account', // client Id
  vimeoVideoLink: 'https://acenda.com/videos', // Link to vimeo acenda video guides
  helpDeskLink: 'https://acenda.com/help', // Link to helpdesk

  defaultConfig: ENVIRONMENT,

  config: {
    tilt: {
      keycloakUrl: 'http://keycloak.lvh.me/auth', // Url to auth against (tilt)
      apiHost: 'api.lvh.me', // host to make api calls against (tilt)
      integrationsHost: 'http://integration-framework.lvh.me/api/',
      channelApiHost: '',
      assetsHost: '',
    },
    dev: {
      //matchHost: 'dev-astur-admin', // host to match against to use dev config
      keycloakUrl: 'https://development-keycloak.acenda.net/auth/', // Url to auth against (dev cluster)
      apiHost: 'dev-api.acenda.net', // host to make api calls against (dev cluster)
      integrationsHost: 'https://integration-framework.acenda.net/api/',
      channelApiHost: 'https://api-channel.acenda.com/api/',
      assetsHost: 'https://assets.acenda.net',
    },
    prd: {
      matchHost: 'admin.acenda.io', // host to match against to use prd config
      keycloakUrl: 'https://login.acenda.io/auth/', // Url to auth against (prd cluster)
      apiHost: 'api.acenda.io', // host to make api calls against (prd cluster)
      integrationsHost: 'https://integration-framework.acenda.io/api/',
      channelApiHost: 'https://api-channel.acenda.com/api/',
      assetsHost: 'https://assets.acenda.io',
    },
  },
};

export const CUSTOM_FIELD_TYPES: CustomFieldType[] = [
  'single_line_text_field',
  'multi_line_text_field',
  'number_integer',
  'number_decimal',
  'date',
  'date_time',
  'boolean',
  'color',
  'url',
  'weight',
  'volume',
  'dimension',
];

export const CUSTOM_FIELD_TYPE_INFO: Record<CustomFieldType, { label: string; description: string }> = {
  single_line_text_field: {
    label: 'Single Line Text Field',
    description: 'A string containing only a single line of text. Line breaks will be automatically replaced with spaces.',
  },
  multi_line_text_field: {
    label: 'Multi Line Text Field',
    description: 'A string that can contain newlines and multiple lines of text.',
  },
  number_integer: {
    label: 'Number Integer',
    description: 'A whole number (e.g., 100, -50). No decimal places allowed.',
  },
  number_decimal: {
    label: 'Number Decimal',
    description: 'A number with decimal places (e.g., 12.99, -3.14).',
  },
  date: {
    label: 'Date',
    description: 'A date in YYYY-MM-DD format (e.g., 2024-07-15).',
  },
  date_time: {
    label: 'Date Time',
    description: 'A date and time in ISO 8601 format with timezone (e.g., 2024-07-15T14:30:00Z).',
  },
  boolean: {
    label: 'Boolean',
    description: 'A true or false value.',
  },
  color: {
    label: 'Color',
    description: 'A hex color code (e.g., #FF0000, #f00).',
  },
  url: {
    label: 'URL',
    description: 'A URL with one of the allowed schemes: https, http, mailto, sms, tel.',
  },
  weight: {
    label: 'Weight',
    description: 'A numeric value with weight unit (lb, oz, g, kg). Default unit: lb.',
  },
  volume: {
    label: 'Volume',
    description: 'A numeric value with volume unit (ml, cl, l, m3, gal, etc). Default unit: l.',
  },
  dimension: {
    label: 'Dimension',
    description: 'A numeric value with length unit (in, ft, yd, mm, cm, m). Default unit: in.',
  },
};
